import React from 'react';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import { Link } from 'react-router-dom';
import { pageTitle } from '../../helpers/PageTitle';

export default function ErrorPage() {
  pageTitle('Error');
  return (
    <div className="cs_dark cs_error cs_center text-center">
      <div className="container">
        <SectionHeading
          title="This page could <br> not be found."
          subTitle="404 Error"
          variantColor="cs_white_color"
        />
        <Spacing lg="30" md="30" />
        <Link to="/" className="cs_btn cs_style_1">
          Back To Home
        </Link>
      </div>
    </div>
  );
}
